<mat-card *ngIf="showAdvanced; else advancedLink" [@inOutAnimation]>
    <div class="filter-header">
        <b>Advanced Search</b>
        <span class="spacer"></span>
        <button mat-icon-button (click)="close()" gtagEvent trackOn="click" action="advanced_search_closed" category="search" [params]="{ user_id: authService.currentUserId }">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="query" *ngIf="query; else noQuery">
        <app-condition #queryView (remove)="query = null" *ngIf="query?.hasOwnProperty('dataField'); else group"
                       [Columns]="columns" [condition]="query" [editable]="editable"></app-condition>
        <ng-template #group>
            <app-group #queryView (remove)="query = null" [columns]="columns" [Operator]="query.operator"
                       [Operands]="query.operands" [editable]="editable"></app-group>
        </ng-template>
    </div>
    <ng-template #noQuery>
        <div class="no-query">
            <button class="add-query-button" mat-raised-button color="accent" [matMenuTriggerFor]="addMenu" gtagEvent trackOn="click" action="add_advanced_query" category="search" [params]="{ user_id: authService.currentUserId }">
                <mat-icon>add</mat-icon>
                Add Query
            </button>
        </div>
    </ng-template>
    <mat-menu #addMenu="matMenu">
        <button mat-button class="menu-button" [color]="themeIsLightColor ? 'accent' : 'primary'" (click)="add()" gtagEvent trackOn="click" action="initial_condition" category="search" [params]="{ user_id: authService.currentUserId }">Condition</button>
        <br>
        <button mat-button class="menu-button" [color]="themeIsLightColor ? 'accent' : 'primary'" (click)="add('and')" gtagEvent trackOn="click" action="initial_and_condition" category="search" [params]="{ user_id: authService.currentUserId }">AND</button>
        <br>
        <button mat-button class="menu-button" [color]="themeIsLightColor ? 'accent' : 'primary'" (click)="add('or')" gtagEvent trackOn="click" action="initial_or_condition" category="search" [params]="{ user_id: authService.currentUserId }">OR</button>
    </mat-menu>
    <mat-card-actions>
        <button mat-stroked-button [color]="themeIsLightColor ? 'accent' : 'primary'" (click)="apply()" gtagEvent trackOn="click" action="apply_query" category="search" [params]="{ user_id: authService.currentUserId }">Apply</button>
        <button mat-stroked-button color="warn" (click)="clear()" [disabled]="!editable" gtagEvent trackOn="click" action="clear_query" category="search" [params]="{ user_id: authService.currentUserId }">Clear</button>
    </mat-card-actions>
</mat-card>
<ng-template #advancedLink>
    <div class="simple-wrapper">
        <mat-form-field appearance="fill">
            <mat-label>Search</mat-label>
            <input matInput placeholder="Search..." [formControl]="simpleSearch">
        </mat-form-field>
        <a class="filter-link" (click)="showAdvanced = !showAdvanced" gtagEvent trackOn="click" action="show_advanced" category="search" [params]="{ user_id: authService.currentUserId }">Show Advanced</a>
    </div>
</ng-template>
